import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../environments/environment";
import { TokenGestao } from "./core/auth.service";
interface Resposta<T> {
  dados: T;
  sucesso: boolean;
}
export interface UsuarioGestao {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
  ultimoLogin?: string;
  dataCadastro: string;
}
export interface EmpresaGestao {
  id: number;
  nome: string;
  email: string;
  ativa: boolean;
  dataCadastro: string;
}
export interface DashboardGestao {
  empresas: number;
  usuariosTenant: number;
  contatos: number;
  empresasRecentes: EmpresaGestao[];
}
@Injectable({ providedIn: "root" })
export class GestaoService {
  private url = `${environment.apiUrl}/GestaoPlataforma`;
  constructor(private http: HttpClient) {}
  login(email: string, senha: string): Observable<Resposta<TokenGestao>> {
    return this.http.post<Resposta<TokenGestao>>(`${this.url}/Login`, {
      email,
      senha,
    });
  }
  dashboard(): Observable<Resposta<DashboardGestao>> {
    return this.http.get<Resposta<DashboardGestao>>(`${this.url}/Dashboard`);
  }
  usuarios(): Observable<Resposta<UsuarioGestao[]>> {
    return this.http.get<Resposta<UsuarioGestao[]>>(`${this.url}/Usuarios`);
  }
  adicionar(dto: {
    nome: string;
    email: string;
    senha: string;
  }): Observable<Resposta<UsuarioGestao>> {
    return this.http.post<Resposta<UsuarioGestao>>(`${this.url}/Usuarios`, dto);
  }
  status(id: number, ativo: boolean) {
    return this.http.put<Resposta<boolean>>(
      `${this.url}/Usuarios/${id}/Status?ativo=${ativo}`,
      {},
    );
  }
  resetarSenha(id: number) {
    return this.http.post<Resposta<boolean>>(
      `${this.url}/Usuarios/${id}/ResetarSenha`,
      {},
    );
  }
}
@Injectable({ providedIn: "root" })
export class OperacaoService {
  private url = `${environment.apiUrl}/BackofficeOperacao`;
  constructor(private http: HttpClient) {}
  listar(r: string) {
    return this.http.get<any>(`${this.url}/${r}`);
  }
  salvar(r: string, d: any, id?: number) {
    return id
      ? this.http.put(`${this.url}/${r}/${id}`, d)
      : this.http.post(`${this.url}/${r}`, d);
  }
  excluir(r: string, id: number) {
    return this.http.delete(`${this.url}/${r}/${id}`);
  }
  acao(p: string) {
    return this.http.post(`${this.url}/${p}`, {});
  }
}
